import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAIL,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  CREATE_SELLER_ACCOUNT_REQUEST,
  CREATE_SELLER_ACCOUNT_SUCCESS,
  CREATE_SELLER_ACCOUNT_FAIL,
  CREATE_SELLER_ACCOUNT_LOGIN_REQUEST,
  CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS,
  CREATE_SELLER_ACCOUNT_LOGIN_FAIL,
  CREATE_TAX_REGISTRATION_REQUEST,
  CREATE_TAX_REGISTRATION_SUCCESS,
  CREATE_TAX_REGISTRATION_FAIL,
  UPDATE_USER_DETAILS_REQUEST,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAIL,
  CLEAR_ERRORS,
} from "../Constants/userContants";

export const sendOtpReducer = (state = { otp: {} }, action) => {
  switch (action.type) {
    case SEND_OTP_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case SEND_OTP_SUCCESS:
      return {
        loading: false,
        otp: action.payload,
      };
    case SEND_OTP_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const userLoginReducer = (state = { user: null }, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case UPDATE_USER_DETAILS_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case USER_LOGIN_SUCCESS:
      return {
        loading: false,
        isAuth: true,
        user: action.payload.user,
      };
    case UPDATE_USER_DETAILS_SUCCESS:
      return {
        loading: false,
        isAuth: true,
        user: action.payload.user,
      };
    case USER_LOGOUT:
      return {
        loading: false,
        isAuth: false,
        user: action.payload.user,
      };
    case USER_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case UPDATE_USER_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const sellerAccountReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case CREATE_SELLER_ACCOUNT_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case CREATE_SELLER_ACCOUNT_SUCCESS:
      return {
        loading: false,
        user: action.payload.user,
      };
    case CREATE_SELLER_ACCOUNT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_TAX_REGISTRATION_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case CREATE_TAX_REGISTRATION_SUCCESS:
      return {
        loading: false,
        user: action.payload.user,
      };
    case CREATE_TAX_REGISTRATION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_SELLER_ACCOUNT_LOGIN_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS:
      return {
        loading: false,
        user: action.payload.user,
      };
    case CREATE_SELLER_ACCOUNT_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_PRODUCT_REQUEST:
      return {
        loading: true,
        ...state,
      };
    case CREATE_PRODUCT_SUCCESS:
      return {
        loading: false,
        ...state,
      };
    case CREATE_PRODUCT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
